import React from "react";
import { map, some, isNil } from "lodash";
import { Link } from "react-router";

// styles

const columnsStyle = {
  display: "flex",
  flexDirection: "column"
};

const menuItemStyle = level => ({
  paddingLeft: 15 * level + "px"
});

const menuItemArrowStyle = {
  fontSize: "11px",
  fontWeight: "normal"
};

const separatorStyle = {
  height: "1px",
  backgroundColor: "#8f8f8f",
  width: "100%"
};

// menu items

const menu = [
  {
    label: "Business Case",
    to: "/analysis/bcase",
    level: 1,
    has_arrow: false,
    children: [
      {
        label: "Executive Summary",
        to: "/analysis/bcase/executive-summary",
        level: 2,
        has_arrow: false
      },
      {
        label: "The Opportunity, Economy, Industry",
        to: "/analysis/bcase/opportunity-economy-industry",
        level: 2,
        has_arrow: false
      },
      {
        label: "The Market",
        to: "/analysis/bcase/market",
        level: 2,
        has_arrow: false
      },
      {
        label: "The Product",
        to: "/analysis/bcase/product",
        level: 2,
        has_arrow: false
      },
      {
        label: "The Operations",
        to: "/analysis/bcase/operations",
        level: 2,
        has_arrow: false
      },
      {
        label: "The Investors",
        to: "/analysis/bcase/investors",
        level: 2,
        has_arrow: false
      }
    ]
  }
];

// components

const isChildrenShown = (item, location) => {
  if (item.to === location) {
    return true;
  }

  if (item.children) {
    return some(item.children, element => isChildrenShown(element, location));
  }

  return false;
};

const MenuItem = ({ has_arrow, global_location, to, label, level, search }) => (
  <Link
    style={menuItemStyle(level)}
    className={to === global_location ? "active" : null}
    to={to + (isNil(search) ? "" : search)}
  >
    {has_arrow === true && (
      <span
        className={
          global_location.indexOf(to) === 0
            ? "fa fa-chevron-down"
            : "fa fa-chevron-right"
        }
        style={menuItemArrowStyle}
      />
    )}{" "}
    {label}
  </Link>
);

const renderItem = (item, global_location, search, key) => {
  if (item.type === "separator") {
    return <hr key={key} style={separatorStyle} />;
  }

  return (
    <MenuItem
      {...item}
      search={search}
      global_location={global_location}
      key={key}
    />
  );
};

const renderItemTree = (location, search) => (item, i) => {
  if (isChildrenShown(item, location)) {
    return [
      <MenuItem {...item} search={search} global_location={location} key={i} />,
      map(item.children || [], renderItemTree(location, search))
    ];
  }

  return renderItem({ ...item, search }, location, search, i);
};

function Menu({ location, search }) {
  return (
    <div style={columnsStyle}>
      {map(menu, renderItemTree(location, search))}
    </div>
  );
}

export default Menu;



// WEBPACK FOOTER //
// ./src/components/bcase/Menu.js